import styled from 'styled-components';
import {
  ButtonContainer,
  CommentContainer,
  UploadedFileDetails,
} from '../common/AssignmentPageLayout/AssignmentPageLayout';

export const StudentUploadedFileDetails = styled(UploadedFileDetails)`
  border: 0;
  font-family: var(--font-family-signika) !important;
  font-size: 20px !important;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: fit-content;
  padding: 0;
`;

export const StudentButtonContainer = styled(ButtonContainer)`
  margin: 10px 0px;

  & > div {
    margin-bottom: 0;
  }
`;

export const StudentCommentContainer = styled(CommentContainer)`
  margin-bottom: 0;
`;
